import i18n from "../../../i18n"
import { validatePhone } from "./validatePhone"

export type ProfileErrorObj = {
    phone: {
        error: boolean,
        message: string
    },
    role: {
        error: boolean,
        message: string
    }
}

export const validateProfileData = (data: any) => {
    const errorObj: ProfileErrorObj = {        
        phone: {
            error: false,
            message: ''
        },
        role: {
            error: false,
            message: ''
        }
    };

    if (!data.phone) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.requiredPhone');
    } else if (!validatePhone(data.phone)) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.incorrectFormatPhone');
    }

    if(!data.role) {
        errorObj.role.error = true;
        errorObj.role.message = i18n.t('errors.requiredPhone');
    }

    return errorObj;
}